import { render, staticRenderFns } from "./prompt.vue?vue&type=template&id=3cee6e59&lang=pug&"
import script from "./prompt.vue?vue&type=script&setup=true&lang=js&"
export * from "./prompt.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./prompt.vue?vue&type=style&index=0&id=3cee6e59&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports